import { axios } from '@/utils/request'

const api = {
    getGoodsList: '/5cf1e535030d6', 
    getTaobaoGoodsDetail: '/5cee2ab1de46d',
    getJingdongGoodsDetail: '/5cef73721040d',
    getPinduoduoGoodsDetail: '/5cf07eb8ed1ae',
    saveGoods: '/5cf1e245a800a', 
    removeGoods: '/5d005d5c380b1', 
    getActivityList: '/5cf1f13671415',
    saveActivity: '/5cf1ee7b7ec90',
    removeActivity: '/5d04cb8a068cf'
}

export default {
    // 获取商品列表
    getGoodsList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getGoodsList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },
    // 获取淘宝商品详情
    getTaobaoGoodsDetail: ({ goodsid, sub_id }) => {
        const parameter = { item_id: goodsid, sub_id }
        return axios({
            url: api.getTaobaoGoodsDetail,
            method: 'post',
            data: parameter
        })
    },
    // 获取京东商品详情
    getJingdongGoodsDetail: ({ goodsid, sub_id }) => {
        const parameter = { skuid: goodsid, sub_id }
        return axios({
            url: api.getJingdongGoodsDetail,
            method: 'post',
            data: parameter
        })
    },
    // 获取拼多多商品详情
    getPinduoduoGoodsDetail: ({ goodsid, sub_id }) => {
        const parameter = { goods_id: goodsid, sub_id }
        return axios({
            url: api.getPinduoduoGoodsDetail,
            method: 'post',
            data: parameter
        })
    },
    //保存新增免单商品
    saveGoods: (parameter) => {
        const params = {
            item_id: parameter.item_id,
            image_url: parameter.image_url,
            title: parameter.title,
            price: parameter.price,
            real_price: parameter.real_price,
            item_type: parameter.item_type
        }
        return axios({
            url: api.saveGoods,
            method: 'post',
            data: params
        })
    },
    // 删除免单商品(数组)
    removeGoods: (ids) => {
        const params = {
            id: ids
        }
        return axios({
            url: api.removeGoods,
            method: 'post',
            data: params
        })
    },
    // 获取免单活动列表
    getActivityList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getActivityList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },
    // 保存免单活动
    saveActivity: (parameter) => {
        const params = {
            sub_id: parameter.sub_id,
            start_time: parameter.start_time,
            end_time: parameter.end_time,
            item_info: parameter.item_info,
            total_free: parameter.total_free,
            peer_limit: parameter.peer_limit,
            use_sub_union: parameter.use_sub_union,
            rebate_type: parameter.rebate_type,
            rebate_percent: parameter.rebate_percent,
            rebate_cash: parameter.rebate_cash,
            user_group: parameter.user_group,
            id: parameter.id,
            user_group: parameter.group
        }
        return axios({
            url: api.saveActivity,
            method: 'post',
            data: params
        })
    },
    // 删除免单活动
    removeActivity: (sub_id,ids) => {
        const params = {
            id: ids,
            sub_id: sub_id
        }
        return axios({
            url: api.removeActivity,
            method: 'post',
            data: params
        })
    }
}
